module.exports = __webpack_public_path__ + "fe02bc551c5bb1ab41e53eaec5cb4de0.png";